<div id="vision-mission" class="watermark">
  <div class="container-fluid px-lg-5">
    <div class="row">
      <div class="col-12">

        <h2 class="title">Vision and Mission</h2>

        <h5 class="mb-4 mt-4" style="font-weight:600;">Ignite Your Prominence, Embrace Your Reverence</h5>

        <p class="inner-lead">
          At Shah Satnam Ji Girls’ College, we believe in <strong>MSG- the magnificent sagaciousness and glistening
            power of our learners</strong>.
          Our institute stands as a beacon of academic excellence, innovation, and community involvement.
          We warmly invite prospective students to explore the myriad opportunities and enriching experiences that our
          institution has to offer.
        </p>

        <div class="row align-items-center mt-4 mb-4">
          <div class="col-lg-6 col-md-12 mb-3 mb-lg-0">
            <img src="/assets/img/library/Vission_mission.png" alt="Vision" class="img-fluid rounded shadow-sm">
          </div>
          <div class="col-lg-6 col-md-12">
            <h5 class="fw-bold" style="color: var(--primary);">Our Vision</h5>
            <p class="inner-lead">
              To be a leading educational institution that fosters the holistic development of women, empowering them to
              become leaders, innovators, and compassionate citizens of the world. We envision a future where our
              graduates excel in their chosen fields and contribute positively to society, embodying the values of
              integrity, empathy, and service.
            </p>

            <h5 class="fw-bold mt-4" style="color: var(--primary);">Our Mission</h5>
            <p class="inner-lead">
              Our mission is to provide a transformative educational experience that fosters intellectual growth,
              personal development, and professional success. We are dedicated to cultivating a vibrant community of
              learners and leaders who make meaningful contributions to the world through their service and engagement.
            </p>
          </div>
        </div>

        <h5 class="fw-bold mt-4 mb-2" style="color: var(--primary);">We aim to</h5>
        <ul class="inner-lead">
          <li>Offer a dynamic and supportive learning environment that encourages academic excellence, creativity, and
            critical thinking.</li>
          <li>Promote a culture of inclusivity, respect, and mutual support, where every student feels valued and
            inspired to reach their full potential.</li>
          <li>Integrate sports, cultural, vocational, and intellectual activities into our curriculum to nurture
            well-rounded individuals.</li>
          <li>Instill a deep sense of humanity and generosity in our students, fostering a more compassionate and
            community-focused world.</li>
        </ul>

        <h5 class="fw-bold mt-4 mb-2" style="color: var(--primary);">Our Commitment</h5>
        <p class="inner-lead">
          Beyond academics, Shah Satnam Ji Girls’ College is dedicated to realizing the essence of being human. We
          strive to uphold humanity as our guiding principle, emphasizing the importance of kindness, empathy, and
          social responsibility. Our objective is not only to achieve excellence in academic performance but also to
          maintain and enhance the essence of humanity in all our endeavours. We believe that by nurturing these values,
          we can create a brighter, more compassionate future for all.
        </p>

        <div class="p-3 mt-4" style="background: #f8d7c5; border-left: 5px solid var(--orange);">
          <p class="inner-lead mb-0 text-center fw-bold">
            We are committed to empowering our students to ignite their prominence and embrace their reverence,
            becoming the change-makers and leaders of tomorrow.
          </p>

        </div>
      </div>
    </div>
  </div>